<template>
  <v-container fill-height fluid pa-0>
    <v-layout fill-height>
      <v-flex lg8>
        <v-layout align-center justify-center>
          <v-card width="500" class="elevation-12">
            <v-card-text>
              <v-container grid-list-lg fluid>
                <v-layout class="mb-1">
                  <v-flex xs12 class="f2-5em text-xs-center text-light k-orange-linear-text">
                    Actualizar contraseña
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout class="my-3">
                  <v-flex xs12 class="text-light">
                    Tu contraseña expirará en: <span style="color: #333">{{ expiration }} dias</span>
                  </v-flex>
                </v-layout>
                <v-layout class="mb-1">
                  <v-flex xs12 class="text-light">
                    La contraseña sera cambiada en todas las compañias donde tienes acceso.
                  </v-flex>
                </v-layout>
                <v-layout row class="mb-3 mt-3">
                  <v-flex xs12 md6>
                    <v-btn class="k-orange-linear white--text" block :to="{ name: 'changePassword' }">Cambiar contraseña</v-btn>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-btn flat style="color: #333 !important" :to="route" block>Continuar</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
      <v-flex hidden-md-and-down lg4 xl4 class="k-orange-linear-d">
        <sidebar>
          <img slot="centered" src="https://s3.amazonaws.com/colektia/CDN/img/logowide.png"  width="80%" alt="Colektia">
        </sidebar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Sidebar from '@/components/login/Sidebar';
import moment from 'moment';

export default {
  inject: ['$validator'],
  components: {
    Sidebar,
  },
  mounted() {
    if(this.$auth.user().role === 'callcenter_analist') {
      this.axios.get('dashboards').then(({ data }) => {
        if (data.dashboards.length > 0) {
          this.dashboard = `/dashboards/${data.dashboards[0].id}`;
        }
      });
    }
  },
  data() {
    return {
      dashboard: '',
    };
  },
  computed: {
    expiration() {
      const current = moment().utc().subtract(1, 'month');
      const last = moment(this.$auth.user().last_password.created_at, 'YYYY-MM-DD HH:mm:ss');
      return last.diff(current, 'days');
    },
    route() {
      localStorage.setItem('duepass', true);
      let route = '/inicio';
      return route;
    },
  },
};
</script>

<style scoped>
  .position-relative {
    position: relative;
  }
  .text-danger {
    color: rgb(255, 82, 82);
  }
  .text-light {
    color: #A0A0A0;
  }
</style>


// WEBPACK FOOTER //
// src/components/login/PasswordDue.vue